import { featureFlagsVar } from '@/graphql/reactiveVars';

import { FeatureFlagName } from './featureFlags.types';

export function isFeatureFlagEnabled(name: FeatureFlagName) {
  return featureFlagsVar()[name];
}
